import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ReportTimeseriesSalesPageRoutingModule } from './report-timeseries-sales-routing.module';

import { ReportTimeseriesSalesPage } from './report-timeseries-sales.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReportTimeseriesSalesPageRoutingModule
  ],
  declarations: [ReportTimeseriesSalesPage]
})
export class ReportTimeseriesSalesPageModule {}
